// @flow
import type { ClearAction } from "./reservation";

export type TicketSetAction = {type: "SET_TICKETS", tickets: Array<Object>};

export type Action = TicketSetAction | ClearAction;

type State = { +tickets: Array<Object> };

let initialState = { tickets: [] };

/** Reducer for reservation actions */
export function tickets(state: State = initialState, action:Action): State {
    if(action.type === "SET_TICKETS") {
        let newState = {...state};
        newState.tickets = [];
        for(var i = 0; i < action.tickets.length; i++) {
            newState.tickets.push({id: action.tickets[i].id, ...action.tickets[i].attributes});
        }
        return newState;
    } else if(action.type === "RESERVATION_CLEARED"){
        return initialState;
    } else {
        return state;
    }
}
